import WithoutCert from './WithoutCert.vue';

export default WithoutCert;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/components/withoutcert/index.ts